module.exports = __webpack_public_path__ + "img/body-1.56de3e59.png";